import { ContentfulSettings } from '../types';
import resolveResponse from 'contentful-resolve-response';

export interface PropertiesRequest {
    include: string;
}

export type GetPropertiesFn = (payload: PropertiesRequest) => Promise<any>;

export function initGetPropertiesFn({
    accessToken,
    baseUrl,
}: ContentfulSettings): GetPropertiesFn {
    return async ({ include }: PropertiesRequest) => {
        const url = `${baseUrl}/entries?${new URLSearchParams({
            content_type: 'Properties',
            include,
        })}`;

        // TODO: move headers and fetch call to a common method that all of the public methods can use
        const headers = {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        };
        const response = await fetch(url, {
            method: 'GET',
            headers,
        });

        if (!response.ok) return Promise.reject(await response.json());
        const data = resolveResponse(await response.json());
        return data?.[0]?.fields?.properties;
    };
}
